import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loadUserProfile } from "../../../redux/actions/userActions";
import { uploadAvatar, uploadBanner } from "../../../redux/actions/settingsActions";
import Spinner from "../../common/Spinner";
import UserAvatar from 'react-user-avatar';
import SettingsAvatarForm from "../SettingsAvatarForm";
import * as apiConfig from "../../../api/config";
import { toast } from "react-toastify";
import $ from 'jquery';

function EditProfileBanner({
    user,
    auth,
    title,
    setupNavigation,
    loadUserProfile,
    updateSiteSettings,
    uploadAvatar,
    uploadBanner,
    settings,
    history,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);
    const [settingDetails, setSettingDetails] = useState({
        firstName: "",
        surname: "",
        email: "",
        location: "",
        preferredMeasurementUnits: "0",
        subscribedMarketingNotification: false,
        subscribedRideBlogsNotification: false,
        approveFollowers: false,
        avatar: { src: "", preview: "" , version: 0 },
        banner: {}
    });

    

    useEffect(() => {
        if (!settings.email) {
            setProcessing(true);
            loadUserProfile(auth.userId, auth.accessToken)
                .then((s) => {
                    s.avatarDetails = { src: "", preview: s.avatar }
                    setSettingDetails(s);
                    setProcessing(false);
                })
        }
        else {
            settings.avatarDetails = { src: "", preview: settings.avatar }
            setSettingDetails(settings); 
            setProcessing(false);
        }
    }, []);

  

    //AVATAR
    function onAvatarClose() {
        var a = { src: settingDetails.avatar.src, preview: settingDetails.avatar };

        setSettingDetails(prevSettingDetails => ({
            ...prevSettingDetails,
            avatarDetails: a
        }));
    }


    function onAvatarCrop(avatarPreview) {
        var a = { src: settingDetails.avatar.src, preview: avatarPreview };

        setSettingDetails(prevSettingDetails => ({
            ...prevSettingDetails,
            avatarDetails: a
        }));
    }


    function onAvatarBeforeFileLoad(e) {
        //if (e.target.files[0].size > 71680) {
        //    alert("File is too big!");
        //    e.target.value = "";
        //};
    }

    function onAvatarSave(event) {
        event.preventDefault();
        settingDetails.avatarDetails.version = ++user.avatarVersion;
        $("#uploadAvatar").modal("hide");
        setProcessing(true);
        uploadAvatar(settingDetails).then(() => {
            toast.success("Avatar Saved");
            setErrors({}); 
            setProcessing(false);
        })
        .catch(error => {
            setProcessing(false);
            setErrors({ onAvatarSave: error.message });
        });
    }

    function onEditAvatar() {
        $("#uploadAvatar").modal("show");
    }

    function openFileUpload() {
        $("#profile-banner-control").click();
    }

    async function uploadProfileBanner(e) {
        if (e.target.files.length > 0) {
            setProcessing(true);
            const config = {
                file: e.target.files[0],
                maxSize: 1280
            };
            const resizedImage = await resizeImage(config)
            settingDetails.banner = { fileName: resizedImage.data, version: ++user.bannerVersion };

            uploadBanner(settingDetails)
                .then(() => {
                    toast.success("Banner Saved");
                    setErrors({});
                    setProcessing(false)
                })
        }
    }

    return (
        processing ?
            <Spinner /> :
            <React.Fragment>
                <div className="profile-banner">
                    <div className="profile-banner-bg-img-gradient"></div>
                    <div className="profile-banner-info">
                        <h2 className="profile-banner-title">{title}</h2>
                    </div>
                    { user.bannerAvailable &&
                        <img className="profile-banner-bg-img" src={`${apiConfig.API_URL}user/banner/${user.id}.png?v=${user.bannerVersion}`} />
                    }
                    <div className="profile-avatar-container">
                        { user.avatarAvailable ?
                            <React.Fragment>
                                <UserAvatar className="profile-banner-avatar d-block d-sm-none" size="100" name={`${user.firstName} ${user.surname}`} src={`${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}`} />
                                <UserAvatar className="profile-banner-avatar d-none d-sm-block" size="150" name={`${user.firstName} ${user.surname}`} src={`${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}`} />
                            </React.Fragment>
                            :
                            <div className="profile-banner-avatar"><span className="fas fa-user"></span></div>
                        }
                        <div className="profile-avatar-edit" onClick={onEditAvatar} ><span className="fas fa-camera"></span></div>
                    </div>
                    <div className="profile-banner-edit" onClick={openFileUpload}>
                        <span className="fas fa-camera"></span> Upload Cover Image
                        <input type="file" accept="image/*" style={{ display: "none" }} id="profile-banner-control" className="form-control" onChange={uploadProfileBanner} />
                    </div>
                </div>
                <div className="modal fade" id="uploadAvatar" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                <h5 className="modal-title">Upload Avatar</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <SettingsAvatarForm
                                    avatar={settingDetails.avatarDetails}
                                    errors={errors}
                                    onCrop={onAvatarCrop}
                                    onClose={onAvatarClose}
                                    onBeforeFileLoad={onAvatarBeforeFileLoad}
                                    onSave={onAvatarSave}
                                    processing={processing}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
    );

}



EditProfileBanner.propTypes =
{
    title: PropTypes.string,
    loadUserProfile: PropTypes.func.isRequired, 
    uploadAvatar: PropTypes.func.isRequired,
    uploadBanner: PropTypes.func.isRequired,
    settings: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    errorMessage: PropTypes.string
}


function mapStateToProps(state) {
    return {
        user: state.user,
        settings: state.settings,
        auth: state.auth
    };
}

const mapDispatchToProps = {
    loadUserProfile,
    uploadAvatar,
    uploadBanner
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileBanner); 

var resizeImage = function (settings) {
    var file = settings.file;
    var maxSize = settings.maxSize;
    var reader = new FileReader();
    var image = new Image();
    var canvas = document.createElement('canvas');
    var dataURItoBlob = function (dataURI) {
        var bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
            atob(dataURI.split(',')[1]) :
            unescape(dataURI.split(',')[1]);
        var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var max = bytes.length;
        var ia = new Uint8Array(max);
        for (var i = 0; i < max; i++)
            ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
    };
    var resize = function () {
        var width = image.width;
        var height = image.height;
        if (width > height) {
            if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
            }
        } else {
            if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
            }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        var dataUrl = canvas.toDataURL('image/png');
        return { blob: dataURItoBlob(dataUrl), data: dataUrl };
    };
    return new Promise(function (ok, no) {
        if (!file.type.match(/image.*/)) {
            no(new Error("Not an image"));
            return;
        }
        reader.onload = function (readerEvent) {
            image.onload = function () { return ok(resize()); };
            image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
    });
};


// WEBPACK FOOTER //
// ./src/components/user/settings/EditProfileBanner.js